export const CustomIntermediateState = `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentcolor" class="fil-icon"><line x1="2" x2="22" y1="12" y2="12"/></svg>`;
export default CustomIntermediateState;